<template>
  <div class="sf-col sf-sm-12 tw-mb-6" :data-testid="'c_' + selectedCompany.id">
    <div
      class="
        sf-level sf-level-between sf-layer-border sf-layer-rounded sf-pad-2
      "
    >
      <ExternalCompanyLabel
        :company-id="selectedCompany.id"
        :company-name="selectedCompany.name"
        :last-synced-at="selectedCompany.lastSyncedAt"
        :ledger-label="ledgerLabel"
        :show-selected-label="true"
      />
      <div class="sf-level-item">
        <SfButton variant="" :small="true" @click="handleSwitchCompany">
          <span class="icon icon-exchange"></span>
          {{ I18n.t('company_links.switch_company_button_label') }}
        </SfButton>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ExternalCompanyLabel from '@app/application/company_links/components/external-company-label.vue'
import SfButton from '@app/shared/vue/components/sf-button/sf-button.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import { useExternalCompaniesStore } from '@app/application/company_links/store/use-external-companies'
import { storeToRefs } from 'pinia'

const I18n = useI18n()

interface Props {
  ledgerLabel: string
}

const { ledgerLabel } = defineProps<Props>()

const externalCompaniesStore = useExternalCompaniesStore()
const { selectedCompany } = storeToRefs(externalCompaniesStore)

function handleSwitchCompany() {
  externalCompaniesStore.clearSelectedCompanies()
  window.modalCitizen.openModalPortal('external-company-selector-modal')
}
</script>
